import { render, staticRenderFns } from "./message-setting.vue?vue&type=template&id=63beb9d5&scoped=true&"
import script from "./message-setting.vue?vue&type=script&lang=js&"
export * from "./message-setting.vue?vue&type=script&lang=js&"
import style0 from "./message-setting.vue?vue&type=style&index=0&id=63beb9d5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63beb9d5",
  null
  
)

export default component.exports